/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { View } from 'backbone.marionette';
import { Modal } from 'bootstrap';

import tmplModalView from './ModalView.hbs';

const ModalView = View.extend({
  template: tmplModalView,

  ui: {
    modalContent: '.custom-content',
    modal: '.modal'
  },

  regions: {
    modalContent: '@ui.modalContent'
  },

  events: {
    'hidden.bs.modal .modal': 'destroy'
  },

  childViewEvents: {
    'modal:close': 'modalClose'
  },

  onRender() {
    this.showChildView('modalContent', this.options.view);
    this.myModal = new Modal(this.$('.modal'), {});
    this.myModal.show();
  },

  modalClose(data, options) {
    const { resolve } = this.options;
    if (resolve && _.isFunction(resolve)) {
      resolve(data, options);
    }
    this.myModal.hide();
  }
});

export default ModalView;
